import { StateEnum, type User } from '../sdk/types/user';

export type GetAvatarOptions = Pick<User, 'avatar' | 'name' | 'avatar_color'>;

export function formatUser(user: User) {
  user.original_name = `${user.first_name || ''}${user.last_name ? ' ' + user.last_name : ''}`;
  user.remark_name = `${user.remark_first_name || ''}${user.remark_last_name ? ' ' + user.remark_last_name : ''}`;
  user.state = Number(user.state || StateEnum.NORMAL);
  if (user.state === StateEnum.DELETE_ACCOUNT) {
    user.avatar = StateEnum.DELETE_ACCOUNT.toString();
    user.name = '';
  } else {
    user.name = user.remark_name || user.original_name;
    user.secondary_name = user.remark_name ? user.original_name : '';
  }

  if (typeof user.have_group_key === 'string') {
    user.have_group_key = user.have_group_key !== '0';
  }

  if (typeof user.have_user_key === 'string') {
    user.have_user_key = user.have_user_key !== '0';
  }

  return user;
}
